<template>
  <div id="cantact">
    <!-- 导航栏 -->
    <!-- <van-nav-bar title="联系我们" fixed @click-right="onClickRight">
      <template #right>
    <van-icon name="manager" size="18" />
  </template>
    </van-nav-bar>-->
    <div class="top-img">
      <img src="@/assets/cantact-top.png" />
    </div>
    <div class="list-info">
      <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-for="(item,index) in news" :key="index">
        <div class="info-detail">
          <div class="info-detail-img">
            <img src="@/assets/online-xin.png" />
          </div>
          <div class="info-detail-address">
            <div class="address-tit">{{item.name}}</div>
            <div class="address-info">{{item.telphone}}</div>
            <div class="address-info">{{item.address}}</div>
          </div>
        </div>
        <div class="bottom-btn">
          <div class="address-btn" @click="toMap(item.address)">
            <img src="@/assets/address.png" />
            <span>查看位置</span>
          </div>
          <div class="phone-btn" @click="callPhone(item.telphone)">
            <img src="@/assets/phone.png" />
            <span>拨打电话</span>
          </div>
        </div>
      </div>
        </van-list>
      </van-pull-refresh>-->
      <div v-for="(item, index) in news" :key="index">
        <div class="info-detail">
          <div class="info-detail-img">
            <img src="@/assets/online-xin.png" />
          </div>
          <div class="info-detail-address">
            <div class="address-tit">{{ item.name }}</div>
            <div class="address-info">{{ item.telphone }}</div>
            <div class="address-info">{{ item.address }}</div>
          </div>
        </div>
        <div class="bottom-btn">
          <div class="address-btn" @click="toMap(item.address)">
            <img src="@/assets/address.png" />
            <span>查看位置</span>
          </div>
          <div class="phone-btn" @click="callPhone(item.telphone)">
            <img src="@/assets/phone.png" />
            <span>拨打电话</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="btns">
      <div class="toMap" @click="toMap()">一键导航</div>
      <div class="toPhone" @click="callPhone(phone)">一键拨号</div>
    </div>
    <div id="container" style="width:100%; height:900px"></div>-->
    <!-- 跳转留言板 -->
    <div class="toChat" @click="toChat">
      留言板
      <!-- <van-icon name="chat-o" size="20" /> -->
    </div>
  </div>
</template>
<script>
import { NavBar, Loading, PullRefresh, List, Icon } from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Loading.name]: Loading,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Icon.name]: Icon,
  },
  data() {
    return {
      phone: "15270935975",
      news: [
        {
          name: "办公室",
          telphone: "85711356",
          address: "南昌县莲塘镇公园路16号",
        },
        {
          name: "服务中心",
          telphone: "85711761",
          address: "南昌县莲塘镇公园路16号",
        },
        {
          name: "安置就业军体科",
          telphone: "85711132",
          address: "南昌县莲塘镇公园路16号",
        },
        {
          name: "就业创业",
          telphone: "85711525",
          address: "南昌县莲塘镇公园路16号",
        },
        {
          name: "优抚褒扬纪念科",
          telphone: "85716882",
          address: "南昌县莲塘镇公园路16号",
        },
        {
          name: "思想政治和权益维护科",
          telphone: "85721768",
          address: "南昌县莲塘镇公园路16号",
        },
        {
          name: "双拥科",
          telphone: "85711706",
          address: "南昌县莲塘镇公园路16号",
        },
      ],
      isLoading: false,
      totalPages: 1,
      padding: false,
      loading: false,
      finished: false,
      page: 0,
    };
  },
  mounted: function () {},
  methods: {
    // 下拉加载
    onLoad() {
      this.getNewsList();
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      // 清空列表数据
      var that = this;
      that.news = [];
      that.page = 0;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getNewsList();
      setTimeout(() => {
        that.refreshing = false;
        // Toast("刷新成功");
        that.isLoading = false;
      }, 1500);
    },
    getNewsList() {
      var that = this;
      var news = this.news;
      var page = this.page + 1;
      var totalPages = this.totalPages;
      var param = {
        page: page,
        pageSize: 5,
      };
      if (totalPages >= page) {
        contact(param).then((res) => {
          ////////(res);
          if (res.status == 1) {
            if (res.data.data.length < 4) {
              this.padding = false;
            }
            that.page = page;
            that.news = news.concat(res.data.data);
            that.totalPages = Math.ceil(
              Number(res.data.total) / res.data.data.length
            );
            if (res.data.data.length == 0) {
              //数据请求成功 但是无数据
              that.finished = true;
              that.loading = false;
              return false;
            }
            if (that.news.length >= news.length) {
              // 数据请求成功后  停止加载状态
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          } else {
            //登录失败
            // Toast(res.message);
          }
        });
      } else {
        // 全部数据加载完毕
        that.finished = true;
      }
    },
    onClickRight() {
      this.$router.push("/mine");
    },
    toMap(k) {
      window.location.href = "//uri.amap.com/search?keyword=" + k;
      //  const map = new AMap.Map('container', {
      //     center: [116.397428, 39.90923],
      //     resizeEnable: true,
      //     zoom: 10
      //   })
      //   map.poiOnAMAP({
      //                     name:'中国国家博物馆',
      //                     location:'116.401304,39.905374',
      //                     id:'B0FFGH2ATP'
      //                 })
      // // this.$router.push('/map')
    },
    callPhone(phone) {
      window.location.href = "tel:" + phone;
    },
    // 跳转
    toChat(){
       this.$router.push("/contant/board");
    },
  },
};
</script>
<style scoped>
/* #cantact{
  padding-top: 46px;
} */
.top-img img {
  width: 100%;
}
.btns {
  display: flex;
}
.btns div {
  width: 50%;
  color: white;
}
.toMap {
  background: yellowgreen;
}
.toPhone {
  background: blue;
}
.list-info {
  padding: 0.3rem;
  background: rgba(248, 248, 248, 1);
}
.info-detail {
  padding: 0.3rem;
  background: white;
  border-radius: 5px;
  display: flex;
}
.info-detail-img {
  width: 20%;
}
.info-detail-img img {
  width: 80%;
}
.info-detail-address {
  width: 80%;
  text-align: left;
  margin-left: 0.3rem;
}
.address-tit {
  font-size: 0.36rem;
  font-weight: bold;
}
.address-info {
  font-size: 0.28rem;
  color: rgba(153, 153, 153, 1);
  margin: 0.2rem 0;
}
.bottom-btn {
  display: flex;
  background: white;
  border-top: solid 1px gainsboro;
  padding: 0.3rem;
  margin-bottom: 0.3rem;
}
.bottom-btn img {
  width: 0.4rem;
}
.address-btn,
.phone-btn {
  /* margin-left: 1rem; */
  width: 50%;
  display: flex;
  align-items: center;
}
.phone-btn {
  /* margin-left: 1.5rem; */

  width: 50%;
}
.bottom-btn span {
  margin-left: 0.1rem;
  font-size: 0.3rem;
}
.toChat {
    position: fixed;
    bottom: 15%;
    right: 0;
    background: #4760ff;
    color: white;
    height: 1rem;
    /* line-height: 30px; */
    width: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px 0 0px 10px;
    font-size: 0.3rem;
}
</style>